'use client';

import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@core/ui/primitives/card';

const ORG_ROADMAP_FEATURES = [
  'Workspace theming controls',
  'Custom organization logo',
  'Self-serve organization deletion',
  'Advanced metrics & reporting',
  'Emergency freeze & publish windows',
  'Audit trail exports',
] as const;

export function OrganizationRoadmapPanel() {
  return (
    <div className='space-y-6 overflow-auto scrollbar-fade'>
      <Card className='bg-transparent border-none shadow-none py-4'>
        <CardHeader>
          <CardTitle className='text-xl'>On the roadmap</CardTitle>
          <CardDescription>
            A preview of the infrastructure and governance capabilities we are building next.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className='list-disc space-y-2 pl-6 text-sm text-muted-foreground'>
            {ORG_ROADMAP_FEATURES.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
